import { createApp } from 'vue';
import ReviewComponent from '@thehotelsnetwork/review-widget/dist/review.es';
import css from '@thehotelsnetwork/review-widget/dist/review.styles';
import { createRootContainer, insertRootContainer } from './chunk-insert-root-container.js';
import './main.js';
import './chunk-widgets.js';
import '@thehotelsnetwork/md5';

const factory = ({ document, thn, }) => {
    const viewData = {};
    const widgetView = {
        data: viewData,
        async create(ctx) {
            const { bundle } = ctx;
            if (viewData.el) {
                return;
            }
            const styleProps = {
                'background-color': 'transparent',
                display: 'block',
                float: 'none',
                left: '0',
                right: '0',
                margin: '0',
                padding: '0',
                border: '0',
                position: 'fixed',
                top: 0,
                visibility: 'hidden',
                'z-index': String(-1 * Number(// Init negative always
                bundle.zIndex)),
            };
            const { shadowEl, topElement, shadowRoot } = createRootContainer({ id: this.data.id, contentStyles: css.toString(), topElementStyles: styleProps }, { document });
            viewData.el = topElement;
            viewData.shadowRoot = shadowRoot;
            viewData.shadowEl = shadowEl;
            // zIndex must be initialized negative and not visible
            topElement.setAttribute('data-thn-visible', '0');
            // attach to document
            const insertArgs = [document.body.lastElementChild ?? document.body, topElement, 'IA'];
            const isRootInserted = insertRootContainer(...insertArgs);
            if (!isRootInserted) {
                const error = new Error('Failed to insert the root container in the DOM');
                this.logger.warn(ctx.debugPrefix, error.message, 'with args:', insertArgs);
                error.status = 'no-selector';
                viewData.error = error; // keep a copy
                throw error;
            }
        },
        async show(ctx) {
            let effectiveEl = viewData.shadowEl || viewData.el;
            if (!effectiveEl) {
                await widgetView.create.call(this, ctx);
                effectiveEl = viewData.shadowEl || viewData.el;
            }
            if (!effectiveEl || !viewData.el) {
                return;
            }
            const { bundle } = ctx;
            // TODO: make sure this goes into the Widget level once the iframe views are deprecated
            this.data.status = 'widget-ok';
            this.data.showed = true;
            bundle.modalRootContainer = viewData.shadowEl || viewData.el;
            await this.container.scheduler.yield();
            viewData.app = createApp(ReviewComponent, { config: bundle });
            viewData.vm = viewData.app.mount(effectiveEl);
            // Make it visible
            viewData.el.style.visibility = 'visible';
            viewData.el.setAttribute('data-thn-visible', '1');
            const zIndex = Number(viewData.el.style.zIndex);
            if (zIndex < 0) {
                viewData.el.style.zIndex = String(zIndex * -1);
            }
        },
        minimize() {
            try {
                viewData.vm?.collapse?.();
            }
            catch (error) {
                this.logger.warn(`Unable to call minimize function on ${this.data.name} widget`, error);
            }
        },
        destroy() {
            if (viewData.error) {
                delete viewData.error;
            }
            if (viewData.app) {
                viewData.app?.unmount();
                delete viewData.app;
                delete viewData.vm;
            }
            if (viewData.el) {
                viewData.el?.remove();
                delete viewData.el;
                delete viewData.shadowEl;
                delete viewData.shadowRoot;
            }
        },
        hide() {
            if (viewData.el) {
                viewData.el.style.visibility = 'hidden';
                viewData.el.setAttribute('data-thn-visible', '0');
                const zIndex = Number(viewData.el.style.zIndex);
                if (zIndex > 0) {
                    viewData.el.style.zIndex = String(zIndex * -1);
                }
            }
        },
    };
    return widgetView;
};

export { factory };
